export default "__VITE_ASSET__BTutdMrY__"